export default __webpack_public_path__ + "static/wall-918b8580ab8fd0de59a43c2d5b9d4f68.jpeg";